// extracted by mini-css-extract-plugin
export default {"root":"styles_root__78p4q","map":"styles_map__E5cGW","content":"styles_content__hc8aK"};